import { register } from '@shopify/theme-sections';
import { formatMoney } from '@shopify/theme-currency';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('product-recommendations', {
  onLoad() {
    this.loadProductRecommendationsIntoSection = function() {
      // Look for an element with class 'product-recommendations'
      var productRecommendationsSection = document.querySelector(
        '.product-recommendations'
      );
      if (productRecommendationsSection === null) {
        return;
      }
      // Read product id from data attribute
      var productId = productRecommendationsSection.dataset.productId;
      // Read limit from data attribute
      var limit = productRecommendationsSection.dataset.limit;
      // Build request URL
      var requestUrl =
        '/recommendations/products?section_id=product-recommendations&limit=' +
        limit +
        '&product_id=' +
        productId;
      // Create request and submit it using Ajax
      var request = new XMLHttpRequest();
      request.open('GET', requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement('div');
          container.innerHTML = request.response;
          productRecommendationsSection.parentElement.innerHTML = container.querySelector(
            '.product-recommendations'
          ).innerHTML;
        }

        const productRecommendationsSlider = document.querySelector(
          '.product-recommendations__slider'
        );
        if (productRecommendationsSlider) {
          var slider = new Flickity(productRecommendationsSlider, {
            freeScroll: false,
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            setGallerySize: true,
            cellAlign: 'left',
            watchCSS: true,
            wrapAround: false,
          });

          Flickity.prototype._createResizeClass = function() {
            this.element.classList.add('flickity-resize');
          };

          Flickity.createMethods.push('_createResizeClass');

          var resize = Flickity.prototype.resize;
          Flickity.prototype.resize = function() {
            this.element.classList.remove('flickity-resize');
            resize.call(this);
            this.element.classList.add('flickity-resize');
          };

          const carouselStatus = document.querySelector('.carousel-status');
          const itemsCount = productRecommendationsSection.dataset.limit;
          let slideNumber = Number(slider.selectedIndex + 1);

          updateStatus(slideNumber, itemsCount);

          slider.on('change', function() {
            slideNumber = Number(slider.selectedIndex + 1);
            updateStatus(slideNumber, itemsCount);
          });

          function updateStatus(count, items) {
            carouselStatus.textContent = count + ' of ' + items;
          }
        }
      };
      request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === 'product-recommendations') {
        this.loadProductRecommendationsIntoSection();
      }
    });
    // Fetching the recommendations on page load
    this.loadProductRecommendationsIntoSection();
  },
});
